import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { CopyLink } from './CopyLink';

export const rehydrator: RehydratorFunction = async (domNode) => {
  const props = elementAttributesToProps(domNode);

  return Promise.resolve(<CopyLink {...props} />);
};

export default rehydrator;
